import React, { useState, useEffect } from "react";

import Gap from "../../../components/Gap";
import DialogLeaderboard from "./dialogLeaderboard";

import Avatar from "@material-ui/core/Avatar";
// import Badge from "@material-ui/core/Badge";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";

import useStyles from "./style/style";

import IconBeauty from "../../../assets/images/iconBeauty";
import Mahkota1 from "../../../assets/icon/mahkota1.png";
import Mahkota2 from "../../../assets/icon/mahkota2.png";
import Mahkota3 from "../../../assets/icon/mahkota3.png";
import Mahkota4 from "../../../assets/icon/mahkota4.png";
import Mahkota5 from "../../../assets/icon/mahkota5.png";

import { isMobile } from "react-device-detect";

import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import { useDocumentDataOnce } from "react-firebase-hooks/firestore";
import { webstoreCollection } from "../../../components/firebase/DataProvider";
// import upperFirst from "lodash/upperFirst";
import { Skeleton } from "@material-ui/lab";

const TopLeaderboard = ({ item, load }) => {
  const classes = useStyles();

  const [webstore] = useDocumentDataOnce(
    webstoreCollection.doc(item?.document_id ?? "unknown")
  );

  return (
    <Grid item xs={4} md={2} lg={2}>
      {load ? (
        <div
          className={
            item?.rank === 1 ? classes.wrapItem : classes.wrapItemLight
          }
          style={{ justifyContent: "center", display: "grid" }}
        >
          <Skeleton
            variant="circle"
            style={{
              width: 50,
              height: 50,
            }}
          />
          <Skeleton variant="text" />
        </div>
      ) : (
        <div
          className={
            item?.rank === 1 ? classes.wrapItem : classes.wrapItemLight
          }
        >
          <img src={item?.mahkota} alt="mahkota1" />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Avatar
              className={classes.medium}
              src={item?.avatar ? item?.avatar : IconBeauty}
            >
              <IconBeauty />
            </Avatar>
          </div>
          <Typography className={classes.liquidLeadrboard}>
            {item?.nama?.split(" ")?.[0]} ****
          </Typography>
        </div>
      )}
    </Grid>
  );
};

function Leaderboard() {
  const classes = useStyles();

  const { profil } = useData();

  const [data, setData] = useState([]);

  const [open, setOpen] = useState(false);
  const [load, setLoad] = useState(false);

  const getData = async () => {
    try {
      setLoad(true);
      const getLeaderboard = firefunctions.httpsCallable("getLeaderboard");

      const res = await getLeaderboard({ find_by: profil?.tipe_akun });
      
      setData(res?.data?.popular_items ?? []);
      setLoad(false);
    } catch (error) {
      console.log(error.message);
      setLoad(false);
    }
  };

  const topFive = React.useMemo(() => {
    const sliced = data.slice(0, 5);

    if (!sliced[4]) {
      sliced[4] = { rank: 5, mahkota: Mahkota5 };
    } else {
      sliced[4].rank = 5;
      sliced[4].mahkota = Mahkota5;
    }

    if (!sliced[3]) {
      sliced[3] = { rank: 4, mahkota: Mahkota4 };
    } else {
      sliced[3].rank = 4;
      sliced[3].mahkota = Mahkota4;
    }

    if (!sliced[2]) {
      sliced[2] = { rank: 3, mahkota: Mahkota3 };
    } else {
      sliced[2].rank = 3;
      sliced[2].mahkota = Mahkota3;
    }

    if (!sliced[1]) {
      sliced[1] = { rank: 2, mahkota: Mahkota2 };
    } else {
      sliced[1].rank = 2;
      sliced[1].mahkota = Mahkota2;
    }

    if (!sliced[0]) {
      sliced[0] = { rank: 1, mahkota: Mahkota1 };
    } else {
      sliced[0].rank = 1;
      sliced[0].mahkota = Mahkota1;
    }
    return [sliced[3], sliced[1], sliced[0], sliced[2], sliced[4]];
  }, [data]);

  const topTree = React.useMemo(() => {
    const sliced = data.slice(0, 3);

    if (!sliced[2]) {
      sliced[2] = { rank: 3, mahkota: Mahkota3 };
    } else {
      sliced[2].rank = 3;
      sliced[2].mahkota = Mahkota3;
    }

    if (!sliced[1]) {
      sliced[1] = { rank: 2, mahkota: Mahkota2 };
    } else {
      sliced[1].rank = 2;
      sliced[1].mahkota = Mahkota2;
    }

    if (!sliced[0]) {
      sliced[0] = { rank: 1, mahkota: Mahkota1 };
    } else {
      sliced[0].rank = 1;
      sliced[0].mahkota = Mahkota1;
    }
    return [sliced[1], sliced[0], sliced[2]];
  }, [data]);

  // console.log("topFive", topFive);

  const topGlobal = isMobile ? topTree : topFive;

  // console.log("topTree", topTree);

  // console.log(data);
  useEffect(() => {
    getData();
  }, []);

  return (
    <Paper elevation={0} className={classes.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <Typography
          style={{
            fontSize: "13px",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          Top Seller
        </Typography>
        <div>
          <Button
            size="small"
            endIcon={<ArrowRightIcon color="primary" />}
            onClick={() => setOpen(true)}
          >
            <Typography color="primary" style={{ fontSize: "11px" }}>
              Lihat semua
            </Typography>
          </Button>
          <DialogLeaderboard
            open={open}
            handleClose={() => setOpen(false)}
            data={data}
            topTree={topTree}
          />
        </div>
      </div>
      <Grid spacing={1} container className={classes.wrapLeaderboard}>
        {topGlobal?.map((item) => (
          <TopLeaderboard key={item?.id} item={item} load={load} />
        ))}
      </Grid>
      <Gap height={20} />
    </Paper>
  );
}

export default Leaderboard;
